var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{attrs:{"value":_vm.value}},_vm._l((_vm.dataSource),function(radioItem){return _c('el-radio',{key:radioItem.value,attrs:{"disabled":"","label":radioItem.value.toString()}},[_vm._v(_vm._s(radioItem.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }